import { createContext } from 'react';


type CardContextType = {
	isSettingsDialogOpen: boolean
}
const CardContext = createContext<CardContextType>(null);
export default CardContext;
